/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-26 15:09:16
 * @LastEditors: chenhongwei chenhw2019@gmail.com
 * @LastEditTime: 2023-05-22 21:11:27
 */
export default {
	team_new_conf(state) {
		return state.teamManage;
	},
};
